import { DestroyRef, Injectable } from '@angular/core';
import { selectors } from '@twaice-fe/frontend/shared/store';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';

const { configsSelectors } = selectors;

@Injectable()
export class ToolbarService {
  constructor(
    private store: Store,
    private destroyRef: DestroyRef
  ) {}

  getLogoUrl$(): Observable<string | null> {
    return this.store.select(configsSelectors.getCustomerConfigurationState).pipe(
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
      map(({ logoUrl }) => logoUrl),
      filter((logoUrl) => !!logoUrl)
    );
  }
}
